import React, { useEffect, useState } from 'react'
import { Form } from 'react-final-form'
import Header from '../components/Header/Header'
import { useSearchStipulationsMutation } from '../../../services'
import { UspConfigurationStipulationViewResult } from '../../../models'
import LeadsStipulationsTable from './components/LeadsStipulationsTable'
import AddEditStipulationsModal from './components/AddEditStipulationsModal'
import { Button, Card, Container, Grid } from '@mui/material'
import CustomBreadcrumbs from '../../../components/custom-breadcrumbs/custom-breadcrumbs'
import Iconify from '../../../components/iconify'

const SettingsLeadsStipulations = () => {
  const [rowData, setRowData] = useState({})
  const [openAddEditModal, setOpenAddEditModal] = useState(false)
  const [type, setType] = useState('')
  const [searchStipulations, { data, isLoading }] = useSearchStipulationsMutation()
  const [stipulationsData, setStipulationsData] = useState<UspConfigurationStipulationViewResult[]>([])

  const handleSubmit = (values?: any) => {
    searchStipulations({
      uspConfigurationStipulationView: {
        searchString: values?.searhString,
        isIncludeInactive: values?.isIncludeInactive,
      },
    })
  }

  const handleOpenModal = () => {
    setOpenAddEditModal(true)
    setType('add')
  }

  const handleCloseModal = () => {
    setOpenAddEditModal(false)
  }

  useEffect(() => {
    if (data) {
      setStipulationsData(data)
    }
  }, [data])

  return (
    <Container>
      <CustomBreadcrumbs
        heading='Stipulations'
        links={[
          {
            name: 'List',
          },
        ]}
        action={
          <Button onClick={handleOpenModal} variant='contained' startIcon={<Iconify icon='mingcute:add-line' />}>
            Add new
          </Button>
        }
        sx={{
          mb: {
            xs: 3,
            md: 5,
          },
        }}
      />
      <Form onSubmit={handleSubmit} initialValues={{ searhString: null, isIncludeInactive: false }}>
        {({ handleSubmit, form: { submit } }: any) => (
          <>
            <form onSubmit={handleSubmit}>
              <Card>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Header submit={submit} title='' handleOpenModal={handleOpenModal} />
                  </Grid>
                  <Grid item xs={12}>
                    <LeadsStipulationsTable
                      data={stipulationsData}
                      loading={isLoading}
                      setData={setStipulationsData}
                      setOpenAddEditModal={setOpenAddEditModal}
                      setType={setType}
                      setRowData={setRowData}
                    />
                  </Grid>
                </Grid>
              </Card>
            </form>
            <AddEditStipulationsModal submit={submit} open={openAddEditModal} onClose={handleCloseModal} type={type} rowData={rowData as any} />
          </>
        )}
      </Form>
    </Container>
  )
}

export default SettingsLeadsStipulations
